import { Controller } from "@hotwired/stimulus";

/**
 * Stimulus controller for switching between different metrics (average/median/sum/max)
 * in numeric field charts without page reload.
 */
export default class extends Controller {
  static targets = ["select"];
  static values = {
    chartId: String,
    averageData: Array,
    medianData: Array,
    sumData: Array,
    maxData: Array,
  };

  connect() {
    // Store reference to the chart instance
    this.chartInstance = null;
  }

  currentMetric() {
    return this.hasSelectTarget ? this.selectTarget.value : "average";
  }

  dataFor(metric) {
    const seriesByMetric = {
      average: this.averageDataValue,
      median: this.medianDataValue,
      sum: this.sumDataValue,
      max: this.maxDataValue,
    };

    return seriesByMetric[metric] ?? this.averageDataValue;
  }

  switch(event) {
    if (this.element.closest("[data-focused='true']")) return;

    const metric = event.target.value;
    const chartContainer = document.getElementById(this.chartIdValue);

    if (!chartContainer) {
      console.warn(`Chart container not found: ${this.chartIdValue}`);
      return;
    }

    const newData = this.dataFor(metric);

    // Find the Chartkick chart instance
    const chart = Chartkick.charts[this.chartIdValue];

    if (chart) {
      // Update the chart data
      chart.updateData(newData);
    } else {
      // Fallback: re-render the chart by updating the container
      this.rerenderChart(chartContainer, newData);
    }
  }

  rerenderChart(container, data) {
    // Clear existing content
    container.innerHTML = "";

    // Create new chart with updated data
    new Chartkick.LineChart(container, data, {
      discrete: true,
      height: "200px",
      precision: 2,
      library: {
        scales: {
          x: {
            grid: { display: false },
            ticks: {
              autoSkip: false,
              maxRotation: 45,
              minRotation: 45,
            },
          },
          y: {
            beginAtZero: true,
            grid: { color: "#f0f0f0" },
          },
        },
        plugins: {
          legend: {
            position: "top",
            align: "start",
          },
          tooltip: {
            mode: "index",
            intersect: false,
          },
        },
        maintainAspectRatio: false,
        tension: 0.3,
      },
    });
  }
}
